// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"7bc418a3","424":"7bc418a3"}[chunkId] + ".chunk.css";
};